import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers.js'
import App from '@/App.vue'
import {COOKIE} from '@/common/const'
import {
  each
} from 'lodash'

Vue.use(Router)

let router = new Router({
  // mode: 'history',
  base: __dirname,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name !== undefined) {
    let name = to.name

    document.body.setAttribute('class', `wp_${name}`)
  }

  let user = Vue.cookie.get(COOKIE.KEY_USER)
  let token = Vue.cookie.get(COOKIE.KEY_TOKEN)

  if (to.meta.needLogin && (!token || !user)) {
    if (!Vue.cookie.get(COOKIE.KEY_REDIRECT)) {
      Vue.cookie.set(COOKIE.KEY_REDIRECT, to.fullPath)
    }
    return next({name: 'login'})
  }
  next()
})

router.afterEach((to) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }

  // auto remove animated class
  router.app.$nextTick(() => {
    each(document.getElementsByClassName('wrapper-content'), node => {
      if (node) {
        setTimeout(() => {
          node.className = node.className.replace('animated', '')
        }, 800)
      }
    })
  })
})
export {router}
export default () => {
  new Vue({
    router,
    render (h) {
      return h(App)
    }
  }).$mount('#app')
}



// WEBPACK FOOTER //
// ./src/router/index.js